import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs';

import { SearchResultDialogActionService } from '@hiptraveler/dialogs/search-result-dialog';
import { AdventuresDataService, skeletons } from '@hiptraveler/modules/search-page-root';
import { RequestCancellationService } from '@hiptraveler/common';
import { opacityFade, opacityFadeIn } from '@hiptraveler/animations';

@Component({
  selector: 'app-things-to-do',
  templateUrl: './things-to-do.component.html',
  viewProviders: [ AdventuresDataService, SearchResultDialogActionService ],
  animations: [ opacityFade(), opacityFadeIn() ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThingsToDoComponent implements OnInit, OnDestroy {

  skeletons: number[] = skeletons;

  constructor(
    private cdRef: ChangeDetectorRef,
    public service: AdventuresDataService,
    private requestCancellation: RequestCancellationService
  ) { }

  ngOnInit(): void {
    this.changeDetectionObserver()
    this.service.initializeDataAccess();
  }

  ngOnDestroy(): void {
    this.requestCancellation.cancelAllRequests();
    this.requestCancellation.cancelAllSearchRequests();
  }

  private changeDetectionObserver(): void {
    this.service.adventures$.pipe(
      takeUntil(this.service.subscription$)
    ).subscribe(() => this.cdRef.detectChanges());
    this.service.adventures$.pipe(
      takeUntil(this.service.subscription$)
    ).subscribe(() => this.cdRef.detectChanges());
    this.service.adventures$.pipe(
      takeUntil(this.service.subscription$)
    ).subscribe(() => this.cdRef.detectChanges());
    this.service.adventures$.pipe(
      takeUntil(this.service.subscription$)
    ).subscribe(() => this.cdRef.detectChanges());
  }

}
